import { Subscription, WorkspaceDefaultProjectAccessMode, WorkspaceDefaultProjectRole, WorkspaceProfile, } from "@supernova-studio/model";
import { DTONpmRegistryConfig } from "./npm-registry";
import { z } from "zod";
//
// Read
//
export const DTOWorkspaceProfile = WorkspaceProfile;
export const DTOWorkspaceDefaultProjectAccessMode = WorkspaceDefaultProjectAccessMode;
export const DTOWorkspaceDefaultProjectRole = WorkspaceDefaultProjectRole;
export const DTOWorkspace = z.object({
    id: z.string(),
    profile: DTOWorkspaceProfile,
    subscription: Subscription,
    npmRegistry: DTONpmRegistryConfig.optional(),
    aiFeaturesEnabled: z.boolean().default(false),
    projectsEnabled: z.boolean().default(false),
    defaultProjectAccessMode: DTOWorkspaceDefaultProjectAccessMode,
    defaultProjectRole: DTOWorkspaceDefaultProjectRole,
    aiAskFeaturesEnabled: z.boolean().default(false),
    aiCustomInstruction: z.string().optional(),
});
//
// Write
//
export const DTOWorkspaceCreateInput = z.object({
    name: z.string(),
});
export const DTOWorkspaceResponse = z.object({
    workspace: DTOWorkspace,
});
